import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { Form } from 'semantic-ui-react';
import { filters } from '@adc/blueprint';
import Text from '../../text';
import InputField from '../../../formFields/inputField';
import DatePickerField from '../../../formFields/datePickerField';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const BLUR_TIMEOUT = 250;
const Field = ({ type, ...props }) => {
    if (type === 'Date') {
        return _jsx(DatePickerField, { ...props });
    }
    else {
        return _jsx(InputField, { ...props });
    }
};
const Range = ({ definition, value, elmId, onChange, }) => {
    const [currentValue, setCurrentValue] = useState(value || { min: null, max: null });
    const currentValueRef = useRef(currentValue);
    useEffect(() => {
        currentValueRef.current = currentValue;
    }, [currentValue]);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const getValueFromEvent = (e) => {
        if (definition.controlValueType === 'number')
            return parseFloat(e.target.value) || null;
        else if (definition.controlValueType === 'Date') {
            const newDate = new Date(e);
            return isNaN(newDate) ? null : newDate;
        }
        else
            return e.target.value;
    };
    const validate = (rangeValue, minOrMax) => {
        let newMin = rangeValue?.min || null;
        let newMax = rangeValue?.max || null;
        if (newMin !== null && newMax !== null && newMin > newMax) {
            if (minOrMax === 'min')
                newMin = null;
            else
                newMax = null;
        }
        return { min: newMin, max: newMax };
    };
    const onChangeHandler = (e, minOrMax) => {
        const val = getValueFromEvent(e);
        const newValue = minOrMax === 'min'
            ? {
                min: val,
                max: currentValue?.max,
            }
            : {
                min: currentValue?.min,
                max: val,
            };
        setCurrentValue(newValue);
    };
    const onBlurHandler = (minOrMax) => {
        setTimeout(() => {
            const newValue = validate(currentValueRef.current, minOrMax);
            setCurrentValue(newValue);
            onChange(definition.name, newValue);
        }, BLUR_TIMEOUT);
    };
    const isDate = definition.controlValueType === 'Date';
    const minValueFormatted = isDate
        ? filters.utils.formatDate(currentValue?.min)
        : currentValue?.min || '';
    const maxValueFormatted = isDate
        ? filters.utils.formatDate(currentValue?.max)
        : currentValue?.max || '';
    return (_jsxs(Form, { className: cx('row-layout', 'range'), children: [_jsxs("div", { className: cx('row-item', {
                    half: definition.controlValueType !== 'Date',
                }), children: [isDate && (_jsx(Text, { color: 'gray', size: 'tiny', className: cx('description'), children: "From" })), _jsx(Field, { type: isDate ? 'Date' : 'input', label: '', name: definition.name, placeholder: isDate ? 'MM/DD/YYYY' : definition.placeholderMin, elmId: `${elmId}_${definition.name}_min`, value: minValueFormatted, onChange: (e) => {
                            onChangeHandler(e, 'min');
                        }, onBlur: () => onBlurHandler('min'), hideWrapper: true, autoComplete: 'off', ...(isDate
                            ? {
                                disabledDays: {
                                    after: currentValue?.max,
                                },
                            }
                            : {}) })] }), _jsxs("div", { className: cx('row-item', 'half'), children: [isDate && (_jsx(Text, { color: 'gray', size: 'tiny', className: cx('description'), children: "To" })), _jsx(Field, { type: isDate ? 'Date' : 'input', label: '', name: definition.name, placeholder: isDate ? 'MM/DD/YYYY' : definition.placeholderMax, elmId: `${elmId}_${definition.name}_max`, value: maxValueFormatted, onChange: (e) => {
                            onChangeHandler(e, 'max');
                        }, onBlur: () => onBlurHandler('max'), hideWrapper: true, autoComplete: 'off', ...(isDate
                            ? {
                                disabledDays: {
                                    before: currentValue?.min,
                                },
                            }
                            : {}) })] })] }));
};
export default Range;
//# sourceMappingURL=range.js.map